import React from 'react'
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText'
import FormWrapper from '../../../../library/form/components/FormWrapper'
import FormSH from '../../../../library/form/components/FormSH';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';

const ItemCMNHeaderEditor = (props) => {
    const { formObject } = props;

    return (
        <div className="uiEditableContent" id="editor">

            <div className="uiCol">
                <ul className="uiHeaderTwoCol">
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Item Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "itemName" }}
                            id="itemNameTxt" className=""
                        />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemCategory" }} >
                        <span ID="eItemCategoryLbl" className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCategory" }} value="Item Category 1" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput uiVal" id="itemCategoryTxt" 
                            action={{ InputType: "ac", paramName: "itemCategory", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                        <FormSH formObject={formObject} rowKey=""
                            action={{ actionId: "new", paramName: "itemCategory",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemCategory2" }} >
                        <span className="uiLbl" >
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCategory2" }} value="Item Category 2" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput uiVal"
                            action={{ InputType: "ac", paramName: "itemCategory2", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                        <FormSH formObject={formObject} rowKey=""
                            action={{ actionId: "new", paramName: "itemCategory2",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemCode" }} value="Item Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "itemCode" }}
                            className=""
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "nickName" }}
                            className=""
                        />
                    </li>
                    <li>
                        <span ID="eReferenceNoLbl" className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refCode" }} value="Reference No"/>
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "refCode" }}
                            id="refCodeTxt" className=""
                        />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "urlShortCode" }} >
                        <span ID="eReferenceNoLbl" className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "urlShortCode" }} value="QR Code"/>
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "urlShortCode" }}
                            id="urlShortCodeTxt" className=""
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "taxGroup" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxGroup" }} value="Tax Group" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput uiVal"
                            action={{ InputType: "ac", paramName: "taxGroup", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />
                        <FormSH formObject={formObject} rowKey=""
                            action={{ actionId: "new", paramName: "taxGroup",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "standardCostContainer" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "standardCost" }} value="Standard Cost" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "standardCost" }}
                            id="standardCostTxt" className=""
                        />
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} />
                    </FormWrapper>
                </ul>
            </div>
            <div className="uiCol">
                <ul className="uiHeaderTwoCol">
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mainUnit" }} value="Main Unit" />
                        </span>
                        <FormInput format="#" formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "mainUnit", acMethod: "CategoryDetail", acDepCtrl: { "dparam": "28" } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "secondaryUnit" }} value="Second Unit" />
                        </span>
                        <FormInput format="#" formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "secondaryUnit", acMethod: "CategoryDetail", acDepCtrl: { "dparam": "28" } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "stdWeight" }} value="Standard Weight" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "stdWeight" }}
                            id="stdWeightTxt" className=""
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "minOrder" }} value="Min Order Qty" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "minOrder" }}
                            id="minOrderQuantTxt" className=""
                        />

                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reorderLevel" }} value="Reorder Level" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "reorderLevel" }} className="" />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "leadTime" }} value="Lead Time (In Days)" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "leadTime" }}
                            id="leadTimeTxt" className=""
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortOrder" }} value="Sort No" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "sortOrder" }}
                            id="sortingTxt" className=""
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isTrack" }} value="Track Inventory" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' roClass="uiSpacerH5"
                            action={{ InputType: "onOff", paramName: "isTrack" }}
                        />
                    </li>
                </ul>
            </div>

            <div className="uiRow">
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "describe" }} value="Description" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="50"
                            action={{ paramName: "describe" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="50"
                            action={{ paramName: "remarks" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "keywords" }} value="Keywords" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="" rows="3" cols="50"
                            action={{ paramName: "keywords" }}
                        />
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default ItemCMNHeaderEditor

